type PictureState = {
  file?: File;
  previewURL: string;
};

export const PICTURE_INITIAL_STATE: PictureState = {
  file: undefined,
  previewURL: '',
};
